//!------edit in table ------

import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import useAxios from "../../../../MainComponents/Hooks/useAxios";
import HelmetTags from "../../../../MainComponents/HelmetTags";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

function AddEditGroup() {
  const navigate = useNavigate();
  const [submitGroup, setSubmitGroup] = useState({
    flag: "",
    dependency: false,
    data: {},
  });
  const [addGroupSuccess, addGroupErrors, submitLoading] = useAxios(
    process.env.REACT_APP_ADD_GROUPS_API,
    "POST",
    submitGroup.flag,
    submitGroup.dependency,
    submitGroup.data,
    true
  );
  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
    reset,
  } = useForm({ mode: "onChange" });

  const onSubmit = (data) => {
    setSubmitGroup({
      flag: "addGroupRequest",
      dependency: !submitGroup.dependency,
      data: { ...data, description: data?.description || null },
    });
  };
  useEffect(() => {
    //! reset the form on success submit

    if (addGroupSuccess) {
      navigate(-1);
      reset();
    }
  }, [addGroupSuccess]);
  return (
    <section className="flex h-full w-full flex-col items-center dark:bg-dark dark:text-light">
      <HelmetTags title="المجموعات | مسيو بلال عبدالله "></HelmetTags>
      <div className="form-container my-20 flex flex-col items-center">
        <h2 className="my-20 text-center text-3xl font-semibold">
          من فضلك قم بملئ البيانات لإضافة المجموعة
        </h2>

        <form
          method="post"
          onSubmit={handleSubmit(onSubmit)}
          className="flex h-fit w-[380px] flex-col  items-center justify-start gap-6 rounded-3xl bg-secondary text-white p-10 shadow-lg shadow-red-200/30 md:w-full "
        >
          {/** group name */}

          <div className=" flex w-full flex-col items-end justify-center gap-2 ">
            <label className="w-full truncate" htmlFor="name">
              اسم المجموعة{" "}
            </label>
            <input
              className="signin-inputs  w-full "
              type="text"
              id="name"
              placeholder="أدخل اسم المجموعة"
              name="name"
              autoComplete="on"
              {...register("name", {
                required: true,

                maxLength: 100,
                minLength: 3,
              })}
            />
            {errors.name && (
              <p className="text-[12px] text-white ">
                {errors.name.type === "required" && "برجاء ملئ هذا الحقل"}

                {errors.name.type === "maxLength" &&
                  "أقصي عدد للحروف هو ١٠٠ حرف"}
                {errors.name.type === "minLength" &&
                  " من فضلك فم بكتابة ٣ أحرف علي الاقل"}
              </p>
            )}
            {
              //!-------server errors -----

              addGroupErrors &&
                addGroupErrors?.response?.data?.errors?.name && (
                  <p className="w-full text-end text-[12px] text-white  ">
                    {addGroupErrors?.response?.data?.errors?.name[0]}
                  </p>
                )
            }
          </div>

          {/** academic level*/}
          <div
            className={`flex w-full flex-col items-end justify-center  gap-2 `}
          >
            <label className="w-full truncate" htmlFor="stage">
              الصف الدراسى{" "}
            </label>
            <select
              name="stage"
              id="stage"
              {...register("stage", { required: true })}
            >
              <option disabled value="" selected>
                الصف الدراسي
              </option>
              <option value="11">الأول الاعدادي</option>
              <option value="22">الثاني الاعدادي</option>
              <option value="33">الثالث الاعدادي</option>

              <option value="1">الأول الثانوي</option>
              <option value="2">الثاني الثانوي</option>
              <option value="3">الثالث الثانوي</option>
            </select>

            {errors.stage && (
              <p className="text-[12px] text-white ">
                {errors.stage.type === "required" && "برجاء ملئ هذا الحقل"}{" "}
              </p>
            )}
            {
              //!-------server errors -----

              addGroupErrors &&
                addGroupErrors?.response?.data?.errors?.stage && (
                  <p className="w-full text-end text-[12px] text-white  ">
                    {addGroupErrors?.response?.data?.errors?.stage[0]}
                  </p>
                )
            }
          </div>

          {/** chapter description */}

          <div className=" flex w-full flex-col items-end justify-center gap-2 ">
            <label className="w-full truncate " htmlFor="description">
              الوصف{" "}
            </label>
            <textarea
              className=" resize-none"
              {...register("description", {
                maxLength: 155,
                minLength: 3,
              })}
              name="description"
              id="description"
              cols="40"
              rows="5"
            ></textarea>
            {errors.description && (
              <p className="text-[12px] text-white ">
                {errors.description.type === "maxLength" &&
                  "أقصي عدد للحروف هو ١٥٥ حرف"}
                {errors.description.type === "minLength" &&
                  " من فضلك فم بكتابة ٣ أحرف علي الاقل"}
              </p>
            )}
          </div>
          {/** submit */}

          <button
            disabled={!isValid || (submitLoading && submitGroup.flag)}
            className=" submit mt-6 w-full "
            type="submit"
          >
            {submitLoading && submitGroup.flag ? (
              <FontAwesomeIcon icon={faSpinner} spin />
            ) : (
              "اضافة الفصل"
            )}
          </button>
        </form>
      </div>
    </section>
  );
}

export default AddEditGroup;
